import { ActionsUnion, createAction } from '../helpers';

export enum ENavigationActionType {
  UPDATE = 'NAVIGATION/UPDATE',
}

export const navigationActions = {
  updateNavigationState: ({
    page,
  }: {
    page?: { screen: string; params: any };
  }) => createAction(ENavigationActionType.UPDATE, { page }),
};

export type TNavigationActions = ActionsUnion<typeof navigationActions>;
